import { employeeDocumentDelDescription as description } from './description';
import { del as execute } from './execute';

export { description, execute };
